<template v-if="pageInclusion.elements">
  <!--Solutions -->

  <div class="landing-diversity">
    <hero :props="pageInclusion.elements" :heroHome="false" :lightbox="true"></hero>

    <section
      class="content-section affinity intro"
      v-in-viewport=""
      v-if="pageInclusion.elements != undefined"
    >
      <div class="inside" v-html="pageInclusion.elements.intro_detail.value"></div>
    </section>

    <!-- <section class="content-description col-xs-12 no-gutters" id="section">
      <div class="goldbox copy col-xs-12 col-md-6">
        <div
          class="inner-text"
          v-if="pageInclusion.elements"
          v-html="pageInclusion.elements.goldbox.value"
        ></div>
      </div>
      <div class="whitebox detail col-xs-12 col-md-6">
        <div
          class="inner-text"
          v-if="pageInclusion.elements"
          v-html="pageInclusion.elements.whitebox.value"
        ></div>
      </div>
    </section> -->

    <!-- <section
      class="content-section slider"
      v-in-viewport=""
      v-if="pageInclusion.elements != undefined"
      :style="setBackgroundImage(pageInclusion.elements.slider_background.value[0].url)"
    >
      <slider :props="sliders"></slider>
    </section> -->

    <section
      class="content-section affinity"
      v-in-viewport=""
      v-if="pageInclusion.elements != undefined"
    >
      <div class="inside" v-html="pageInclusion.elements.affinity_section.value"></div>
    </section>

    <section
      class="content-section goals"
      v-in-viewport=""
      v-if="pageInclusion.elements != undefined"
    >
      <div class="inside" v-html="pageInclusion.elements.goals_intro.value"></div>
      <div
        class="inside table-desktop"
        v-html="pageInclusion.elements.goals_table_desktop.value"
      ></div>
      <div
        class="inside table-mobile"
        v-html="pageInclusion.elements.goals_table_mobile.value"
      ></div>
      <div class="inside" v-html="pageInclusion.elements.goals.value"></div>
    </section>

    <!-- Related Works -->
    <!-- <section class="content-works col-xs-12 no-gutters">
      <div class="inside">
        <h2 class="text-center container-fluid" v-in-viewport="">Case Studies</h2>
        <p class="related container">
          Big ideas drive innovation and are essential in engaging customers. Big ideas
          need big execution, too. That’s why our team is organized and focused on the
          four areas innovative companies need most:
        </p>
        <boxes-wrapper
          :boxes="relatedWorks"
          :boxlimit="3"
          :showViewAll="true"
        ></boxes-wrapper>
      </div>
    </section> -->

    <!-- Insights, Commentary and News  -->
    <section class="content-articles insights" v-in-viewport="">
      <div class="inside">
        <h2 class="text-center" v-in-viewport="">Insights, Commentary and News</h2>
        <articles-wrapper
          :boxes="relatedArticles"
          :isHome="true"
          :boxlimit="4"
          :pathRoute="'/words'"
          :showCategory="true"
          :showViewAll="true"
        ></articles-wrapper>
      </div>
    </section>
  </div>
  <!-- End Solutions -->
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import common from "../mixins/common.js";
import boxesWrapperInclusion from "../components/boxes-wrapper-inclusion.vue";
import articlesWrapper from "../components/articles-wrapper.vue";
import moreList from "../components/more-list.vue";
import hero from "../components/hero.vue";
import slider from "../components/slider.vue";

export default {
  name: "Diversity",
  data() {
    return {
      relatedWorks: [],
      relatedArticles: [],
      marketDetail: [],
      // markets: [],
      pageInclusion: [],
      modularContent: [],
      sliders: [],
    };
  },
  created: function () {
    this.getInclusionPage();
    setTimeout(function () {
      var x = $(".VueCarousel-dot-container").width();
      $(".VueCarousel-navigation-prev").css(
        "left",
        "calc(50% - " + (x / 2 + 20) + "px )"
      );
      $(".VueCarousel-navigation-next").css(
        "right",
        "calc(50% - " + (x / 2 + 20) + "px )"
      );

      if ($(".VueCarousel-dot-container").children().length < 2) {
        $(".VueCarousel-navigation").hide();
      } else {
        $(".VueCarousel-navigation").show();
      }
    }, 1500);
  },
  components: {
    "boxes-wrapper": boxesWrapperInclusion,
    "articles-wrapper": articlesWrapper,
    "more-list": moreList,
    hero: hero,
    slider: slider,
  },
  mixins: [apiConnection, seoModule, common],
};
</script>



// WEBPACK FOOTER //
// Inclusion.vue?3914c67a